import React, {useState, useEffect} from 'react';
import NavBar from '../pages/NavBarPage';
import { AlertTriangle } from "lucide-react";
import { Footer } from '../pages/FooterPage';
import { fetchSysConfig } from '../services/api/KaiConfigData';

// import { useSystemMessage } from '../../hooks/useSystemMessage';
interface NotFoundProps {
  title: string;
  message: string;
}


const NotFound: React.FC<NotFoundProps> = ({ title, message }) => {
  // const title = useSystemMessage('UnauthorizedPageTitle', 'Not Authorized!');
  // const message = useSystemMessage('UnauthorizedPageHeader', 'Sorry! you are not authorized to view this page.');
  // const title = 'Not Authorized!';
  // const message = 'Sorry! you are not authorized to view this page.';
  const [email, setEmail] = useState<string | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchSysConfig();
      const dt: { id: string; val: string }[] = result.data;
      const email = dt.find(item => item.id === "default_support_email")?.val ?? "support@example.com";
      setEmail(email)
    };
    if(title !== 'unauthorised' && title !== 'not-saved')
      fetchData();
  }, []);

  useEffect(() => {
  },[email]);


  return (
    <div>
       { title === 'unauthorised' ? (
      <div >
        <NavBar />
        <div className="not-enrolled-container">
      <div>
       <h2>It looks like that you currently do not have access to this chatbot.</h2>
<p>Please contact IT support for assistance.</p>
      </div>
    </div>
    </div>
      ) : title === 'not-saved' ? (  <div>
        <NavBar />
        <div className="not-enrolled-container">
          <div>
            <h2>It seems that your assistant is not saved yet.</h2>
            <p>Preview will be available once the assistant has been saved.</p>
          </div>
        </div>
      </div> ): 
      <div id="wrapper" className="mt-0 md:mt-10">
  <NavBar />
  <div className="access-restricted-container w-full min-h-screen bg-gray-50 py-10 px-4">
    <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-8">
      <div className="flex justify-center mb-6">
        <div className="bg-amber-100 p-3 rounded-full">
          <AlertTriangle   className="w-10 h-10 text-gray-500" />
        </div>
      </div>
      
      <h1 className="text-2xl font-bold text-gray-800 mb-2 text-center">URL Unavailable</h1>
      <p className="text-gray-600 mb-6 text-center">This application is currently unavailable</p>
      
      <div className="bg-gray-50 rounded-lg p-4 mb-6">
        <p className="text-gray-700 font-medium mb-3">This could be because:</p>
        <ul className="space-y-2 text-gray-600 pl-5 list-disc">
          <li>The application hasn't been published yet</li>
          <li>You don't have the required permissions</li>
          <li>The application has been temporarily disabled</li>
          <li>The URL you've entered is incorrect</li>
        </ul>
      </div>
      
      <div className="mb-6">
        <p className="text-gray-700 font-medium mb-3">What you can do:</p>
        <ul className="space-y-2 text-gray-600">
          <li className="flex items-start">
            <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            Verify you're using the correct link
          </li>
          <li className="flex items-start">
            <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            Check if you're logged in with the right account
          </li>
          <li className="flex items-start">
            <svg className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            Contact your administrator for access permission
          </li>
         
        </ul>
      </div>
      
     
      <div className="mt-6 pt-4 border-t border-gray-200">
        <p className="text-sm text-gray-500 text-center">
          Need help? Contact support at <a href="mailto:support@example.com" className="text-blue-600 hover:underline">{email}</a> 
          <br />
        </p>
      </div>
    </div>
  </div>
</div>
}
    
    </div>
  );
};

export default NotFound;